var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBelysning2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    "data-name": "Lager 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60.62 60.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {fill:#fff; stroke: #010101; stroke-miterlimit: 11.34; stroke-width: 2px; }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g1023"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "path996",
    className: "cls-1",
    cx: 30.05,
    cy: 30.56,
    r: 13.24
  }), /*#__PURE__*/React.createElement("path", {
    id: "path998",
    className: "cls-1",
    d: "M32.38,4.14V15.85",
    transform: "translate(-2.32 -4.14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1000",
    className: "cls-1",
    d: "M53.67,13.3,45.11,22",
    transform: "translate(-2.32 -4.14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1002",
    className: "cls-1",
    d: "M62.94,34.7H51.23",
    transform: "translate(-2.32 -4.14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1004",
    className: "cls-1",
    d: "M53.67,56.09l-8.56-8.66",
    transform: "translate(-2.32 -4.14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1006",
    className: "cls-1",
    d: "M11,56.09l8.66-8.66",
    transform: "translate(-2.32 -4.14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1008",
    className: "cls-1",
    d: "M11,13.3,19.64,22",
    transform: "translate(-2.32 -4.14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1010",
    className: "cls-1",
    d: "M2.32,34.7H14",
    transform: "translate(-2.32 -4.14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1012",
    className: "cls-1",
    d: "M32.38,64.75V53",
    transform: "translate(-2.32 -4.14)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBelysning2);
export default __webpack_public_path__ + "static/media/belysning2.fb37601f4d7d565f5a6f2c6b22ea3afd.svg";
export { ForwardRef as ReactComponent };